import {Separator, Stack} from '@fluentui/react';
import {ControlledTagPicker} from 'components/hookForms';
import {ControlledChoiceGroup} from 'components/hookForms/ControlledChoiceGroup';
import {LoadWrapper} from 'components/LoadWrapper';
import {
	GetPogisDocumentsEtbDocument,
	useGetPogisDocumentsEtbQuery,
} from 'features/Archive/hooks/PogisDocuments.generated';
import React, {useMemo} from 'react';
import {Control, UseFormWatch} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {RegulatoryDocument} from 'types';

type PogisPickerProps = {
	control: Control<RegulatoryDocument>;
	watch: UseFormWatch<RegulatoryDocument>;
};
export const PogisPicker: React.FC<PogisPickerProps> = ({control, watch}) => {
	const {data, loading} = useGetPogisDocumentsEtbQuery();
	const {t} = useTranslation('features/pogisdocuments', {
		keyPrefix: 'Reference',
	});
	const optionsChoiceGroup = [
		{key: 'no', text: t('no')},
		{key: 'yes', text: t('yes')},
	];

	const getSelectedKey = (value: any) => {
		return value === true ? 'yes' : 'no';
	};
	const getValue = (selection: {key: string; text: string} | undefined) => {
		return selection?.key === 'yes';
	};
	const watchPogisExist = watch('pogisExists');
	const optionsPogisPicker = useMemo(
		() =>
			(data?.pogisDocumentsETB ?? [])
				.slice()
				.sort((a, b) => Number(b.pogisId) - Number(a.pogisId)),
		[data],
	);
	return (
		<Stack>
			<Separator />
			<ControlledChoiceGroup
				control={control}
				name={'pogisExists'}
				label={t('AlreadyCommunicated')}
				options={optionsChoiceGroup}
				getSelectedKey={getSelectedKey}
				getValue={getValue}
			/>
			{watchPogisExist && !loading && (
				<ControlledTagPicker
					control={control}
					name={'pogisDocuments'}
					label={t('pogisDocuments')}
					selectableItems={optionsPogisPicker}
					getName={x => x.pogisId}
				/>
			)}
			{watchPogisExist && loading && <LoadWrapper loading={true} />}
			<Separator />
		</Stack>
	);
};
